var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoT(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 90,
    viewBox: "0 0 63 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0532 107.879V41.082H10.1548V40.5938L14.1099 32.1953H61.7173V32.6836L57.7622 41.082H40.8188V103.484L31.5415 107.879H31.0532Z",
    fill: "#F58840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1426 106.953V40.1562H9.24414V39.668L13.1992 31.2695H60.8066V31.7578L56.8516 40.1562H39.9082V102.559L30.6309 106.953H30.1426Z",
    fill: "#32746C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0713 105.894V39.0967H8.17285V38.6084L12.1279 30.21H59.7354V30.6982L55.7803 39.0967H38.8369V101.499L29.5596 105.894H29.0713Z",
    fill: "#F58840"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1426 104.953V38.1562H7.24414V37.668L11.1992 29.2695H58.8066V29.7578L54.8516 38.1562H37.9082V100.559L28.6309 104.953H28.1426Z",
    fill: "#32746C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0889 103.908V37.1113H6.19043V36.623L10.1455 28.2246H57.7529V28.7129L53.7979 37.1113H36.8545V99.5137L27.5771 103.908H27.0889Z",
    fill: "#F58840"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1426 102.953V36.1562H5.24414V35.668L9.19922 27.2695H56.8066V27.7578L52.8516 36.1562H35.9082V98.5586L26.6309 102.953H26.1426Z",
    fill: "#32746C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1069 101.923V35.126H4.2085V34.6377L8.16357 26.2393H55.771V26.7275L51.8159 35.126H34.8726V97.5283L25.5952 101.923H25.1069Z",
    fill: "#F58840"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1426 100.953V34.1562H3.24414V33.668L7.19922 25.2695H54.8066V25.7578L50.8516 34.1562H33.9082V96.5586L24.6309 100.953H24.1426Z",
    fill: "#32746C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1069 100.026V33.2295H2.2085V32.7412L6.16357 24.3428H53.771V24.8311L49.8159 33.2295H32.8726V95.6318L23.5952 100.026H23.1069Z",
    fill: "#F58840"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 98.9902V32.1934H1.22656V31.7051L5.18164 23.3066H52.7891V23.7949L48.834 32.1934H31.8906V94.5957L22.6133 98.9902H22.125Z",
    fill: "#32746C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1426 97.9531V31.1562H0.244141V30.668L4.19922 22.2695H51.8066V22.7578L47.8516 31.1562H30.9082V93.5586L21.6309 97.9531H21.1426Z",
    fill: "#F58840"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoT);
export default __webpack_public_path__ + "static/media/logoT.2fe3b2db0e68b0d7a9f6b6e77ca64cce.svg";
export { ForwardRef as ReactComponent };